import { Box, Typography } from '@mui/material';
import { TournamentTeamEntity } from 'app/interfaces/entity';
import goldTrophy from 'assets/images/trophy-gold.png';
import React, { FC } from 'react';
import { TeamIcon } from 'shared/components/TeamIcon';
import { useStyles } from './WinnerBracketSeedCard.styles';

interface WinnerBracketSeedCardProps {
  team?: TournamentTeamEntity;
}

export const WinnerBracketSeedCard: FC<WinnerBracketSeedCardProps> = ({ team }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      {team && (
        <Box display="flex" alignItems="center">
          <TeamIcon size={32} mr={1} team={team} />
          <Typography className={classes.text}>{team?.name}</Typography>
        </Box>
      )}
      <Box className={classes.trophy}>
        <img src={goldTrophy} alt="gold-trophy" />
      </Box>
    </Box>
  );
};
